import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import help_icon from '../../images/help_icon.png';

function HelpBtn() {
  const { t } = useTranslation();
  return (
    <Button variant='' className="help_btn shadow">
      <span className="help-icon-wrapper">
        <img
          src={help_icon}
          alt="Help"
          className="img-fluid"
          style={{ width: '24px', height: '24px', objectFit: 'contain' }}
        />
      </span>
      <span className="help-text">{t('help.need_help')}</span>
    </Button>
  );
}

export default HelpBtn;
